// import { useEffect, useState } from "react"
// import axios from "axios"
// import { MainWrap } from "../../utilities/Shared"

// const EndOfMonth = () => {
//   const [rows, setRows] = useState([])
//   const [loading, setLoading] = useState(true)

//   useEffect(() => {
//     try{
//     axios.get("https://highgroundsoftware.com/dash/dashboard/admin/eom4.php")
             
//       .then(res => setRows(res.data))
//       .finally(() => setLoading(false))
//     }catch (err){
// console.log(err)
//     }
//   }, [])

//   const downloadCSV = () => {
//    // window.location.href = "/api/eom-csv.php"
//   }

//   if (loading) return <h2>Loading End of Month…</h2>

//   return (
//     <MainWrap style={{ padding: 20 }}>
//       <h2>End of Month Report</h2>

//       <div style={{ marginBottom: 10 }}>
//         <button onClick={() => window.print()}>Print</button>
//         <button onClick={downloadCSV} style={{ marginLeft: 10 }}>
//           Download CSV
//         </button>
//       </div>

//       <table width="100%" border="1" cellPadding="6">
//         <thead>
//           <tr>
//             <th>Job</th>
//             <th>Due</th>
//             <th>Name</th>
//             <th>Customer</th>
//             <th>Labor</th>
//             <th>Material</th>
//             <th>Total</th>
//           </tr>
//         </thead>
//         <tbody>
//           {rows.map(r => (
//             <tr key={r.job}>
//               <td>{r.job}</td>
//               <td>{r.due}</td>
//               <td>{r.name}</td>
//               <td>{r.customer}</td>
//               <td align="right">${r.labor.toFixed(2)}</td>
//               <td align="right">${r.materials.toFixed(2)}</td>
//               <td align="right">${r.total.toFixed(2)}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </MainWrap>
//   )
// }

// export default EndOfMonth


import { useEffect, useState } from "react"
import axios from "axios"
import { MainWrap } from "../../utilities/Shared"

const EndOfMonth = () => {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    axios
      .get("https://highgroundsoftware.com/dash/dashboard/admin/eom4.php")
      .then(res => setRows(res.data || []))
      .catch(err => console.error(err))
      .finally(() => setLoading(false))
  }, [])

  const downloadCSV = () => {
    if (!rows.length) return

    const headers = [
      "Job",
      "Due",
      "Name",
      "Customer",
      "Labor",
      "Materials",
      "Total"
    ]

    const csvRows = [
      headers.join(","), // header row
      ...rows.map(r =>
        [
          r.job,
          r.due,
          `"${r.name}"`,
          `"${r.customer}"`,
          r.labor.toFixed(2),
          r.materials.toFixed(2),
          r.total.toFixed(2)
        ].join(",")
      )
    ]

    const blob = new Blob([csvRows.join("\n")], {
      type: "text/csv;charset=utf-8;"
    })

    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.download = "end_of_month_report.csv"
    link.click()
    URL.revokeObjectURL(url)
  }

  if (loading) return <h2>Loading End of Month…</h2>

  return (
    <div style={{ padding: 20 }}>
        <div style={{display:'flex',padding:'10px'}}>
             <p style={{fontSize:'clamp(2rem,2rem,2rem)',flex:'1'}}>End of Month Report</p>
<div style={{ textAlign:'right' }}>
  <button
    style={{
   flex:'1',
      padding: "8px 12px",
      background: "green",
      color: "white",
      fontSize: 16
    }}
    onClick={downloadCSV}
  >
    DOWNLOAD CSV
  </button>
</div>
        </div>
     


      <table width="100%" border="1" cellPadding="6">
        <thead>
          <tr>
            <th>Job</th>
            <th>Due</th>
            <th>Name</th>
            <th>Customer</th>
            <th style={{textAlign:'right'}}>Labor</th>
            <th style={{textAlign:'right'}}>Material</th>
            <th style={{textAlign:'right'}}>Total</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(r => (
            <tr key={r.job} className='normalrow' >
              <td >{r.job}</td>
              <td>{r.due}</td>
              <td>{r.name}</td>
              <td>{r.customer}</td>
              <td style={{ textAlign: "right" }}>
                ${r.labor.toFixed(2)}
              </td>
              <td style={{ textAlign: "right" }}>
                ${r.materials.toFixed(2)}
              </td>
              <td style={{ textAlign: "right" }}>
                ${r.total.toFixed(2)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default EndOfMonth

